import EasyValidation from './validationHelper.js';

// Variables

const validate = new EasyValidation();

const apiURL =
  'http://172.16.61.31:7106/api/VacancyMaster/GetAllPublishedVacancy?clientId=14';
const BASEURL =
  'http://172.16.61.31:7106/api/CandidateApplied/InsertCandidateApplied';

// Elements
const ddlVacancy = document.getElementById('ddlVacancy');
const txtName = document.getElementById('txtName');
const txtMobile = document.getElementById('txtMobile');
const txtEmail = document.getElementById('txtEmail');
const txtLocation = document.getElementById('txtLocation');
const txtNoticePeriod = document.getElementById('txtNoticePeriod');
const txtCurrentExperience = document.getElementById('txtCurrentExperience');
const txtCurrentCtc = document.getElementById('txtCurrentCtc');
const txtFile = document.getElementById('txtFile');
const chkPolicy = document.getElementById('chkPolicy');
const btnSubmit = document.getElementById('btnSubmit');
const successToast = document.getElementById('successToast');
const errorToast = document.getElementById('errorToast');
let currentDateTime = new Date().getMilliseconds();

let submitCount = 0;

window.addEventListener('load', async () => {
  const response = await fetch(apiURL);
  const data = await response.json();

  if (data.status === 1 && Array.isArray(data.responseValue)) {
    data.responseValue.forEach((item) => {
      const option = document.createElement('option');
      option.value = item.id;
      option.textContent = item.designationName;
      ddlVacancy.appendChild(option);
    });
  } else if (data.status === 0) {
    errorToast.style.display = 'block';
    errorToast.querySelector('.toast-body').textContent = data.responseValue;
    setTimeout(() => {
      errorToast.style.display = 'none';
      btnSubmit.removeAttribute('disabled');
      btnSubmit.innerHTML = 'SUBMIT';
    }, 5000);
  }
});

ddlVacancy.addEventListener('change', () => validateDropdown(ddlVacancy));
txtName.addEventListener('blur', () => validate.name(txtName));
txtMobile.addEventListener('blur', () => validate.number(txtMobile));
txtEmail.addEventListener('blur', () => validate.email(txtEmail));
txtLocation.addEventListener('blur', () => validate.location(txtLocation));
txtNoticePeriod.addEventListener('blur', () =>
  validate.noticePeriod(txtNoticePeriod)
);
txtCurrentExperience.addEventListener('change', () =>
  validate.currentExperience(txtCurrentExperience)
);
txtCurrentCtc.addEventListener('change', () =>
  validate.currentCtc(txtCurrentCtc)
);
txtFile.addEventListener('change', () => validate.fileValidation(txtFile));

// Utility functions
const postWithFormData = async (url, data) => {
  const response = await fetch(url, {
    method: 'POST',
    body: data,
  });

  // Parse and return the JSON response
  return response.json();
};

const jsonToFormConverter = () => {
  const formData = new FormData();
  formData.append('VacancyId', ddlVacancy.value);
  formData.append('CandidateName', txtName.value);
  formData.append('MobileNumber', txtMobile.value);
  formData.append('Email', txtEmail.value);
  formData.append('Experience', txtCurrentExperience.value);
  formData.append('CurrentCTC', txtCurrentCtc.value);
  formData.append('LocationName', txtLocation.value);
  formData.append('NoticePeriod', txtNoticePeriod.value);

  const file = txtFile.files[0];
  const updatedFileName = `${file.name}_${currentDateTime}`;

  const updatedFile = new File([file], updatedFileName, { type: file.type });

  formData.append('CvFile', updatedFile);

  formData.append('ClientId', '14');

  return formData;
};

const resetFields = () => {
  ddlVacancy.value = '';
  txtName.value = '';
  txtMobile.value = '';
  txtEmail.value = '';
  txtLocation.value = '';
  txtNoticePeriod.value = '';
  txtCurrentExperience.value = '';
  txtCurrentCtc.value = '';
  txtFile.value = '';
  chkPolicy.checked = false;
  submitCount = 0;
};

btnSubmit.addEventListener('click', async (e) => {
  e.preventDefault();

  if (submitCount < 1) {
    if (
      validate.dropdown(ddlVacancy) ||
      validate.name(txtName) ||
      validate.number(txtMobile) ||
      validate.email(txtEmail) ||
      validate.location(txtLocation) ||
      validate.noticePeriod(txtNoticePeriod) ||
      validate.currentExperience(txtCurrentExperience) ||
      validate.currentCtc(txtCurrentCtc) ||
      validate.fileValidation(txtFile) ||
      validate.checkBox(chkPolicy)
    ) {
      e.stopPropagation();
    } else {
      btnSubmit.setAttribute('disabled', true);
      btnSubmit.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      `;

      submitCount++;

      const formData = jsonToFormConverter();
      const response = await postWithFormData(BASEURL, formData);

      if (response.status === 1) {
        resetFields();
        successToast.style.display = 'block';
        setTimeout(() => {
          successToast.style.display = 'none';
          btnSubmit.removeAttribute('disabled');
          btnSubmit.innerHTML = 'SUBMIT';
        }, 5000);
      } else {
        errorToast.style.display = 'block';
        setTimeout(() => {
          errorToast.style.display = 'none';
          btnSubmit.removeAttribute('disabled');
          btnSubmit.innerHTML = 'SUBMIT';
        }, 5000);
      }
    }
  }
});
